import { Cache } from 'aws-amplify'
import CountdownTimer from 'components/ui/countdown-timer/CountdownTimer'
import { triggerTagging } from 'components/util/common-utils'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateCouponCodeValidity } from 'state/actions/dogAction'
import LinkRoute from '../../ui/link/Link'
import LinkButton, { LinkButtonProp } from '../common/button'

enum Position {
  Bottom = 'bottom',
  Top = 'top'
}
interface Props {
  bannerTopic: string
  bannerTopicLong: string
  bannerTopicCarousel?: string
  bannerTopicLongCarousel?: string
  enableCarousel?: boolean
  backgroundColor: string
  fontColor: string
  icon: string
  stickyBottom: boolean
  bannerPosition: Position
  buttonProps: LinkButtonProp
  buttonUrlCarousel?: string
  buttonTextCarousel?: string
  centered: boolean
  showCustomText: boolean
  buttonEnabled: boolean
  showTimer: boolean
}

const StickyWrapper = ({ children, position }: { children: any; position: Position }) => {
  const bannerPositionClass = position === Position.Top ? 'top-0' : 'bottom-0'

  return <div className={`fixed inset-x-0 ${bannerPositionClass}`}>{children}</div>
}

const InnerContent = ({
  className,
  buttonProps,
  centered,
  bannerTopic,
  bannerTopicLong,
  fontColor,
  buttonEnabled,
  showTimer
}: any) => {
  const [scrollToSection, setScrollToSection] = useState<HTMLElement | null>(null)
  const [displayDeal, setDisplayDeal] = useState(true)
  const midnight = dayjs().add(1, 'day').startOf('day').toDate()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Find the first element with an ID containing "Route"
      const matchingElement = Array.from(document.querySelectorAll<HTMLElement>('[id]')).find(el =>
        el.id.includes('Route')
      )

      if (matchingElement) {
        setScrollToSection(matchingElement as HTMLElement)
      }
    }
  }, [])

  if (showTimer) {
    return (
      <div className={`flex justify-center items-center sm:px-16 -my-3 sm:gap-6 ${className}`}>
        <div className={`${displayDeal ? 'w-1/2' : 'w-full'} flex justify-end`}>
          <p className="text-sm font-medium text-center sm:text-base md:mr-5 md:mb-0" style={{ color: fontColor }}>
            <span dangerouslySetInnerHTML={{ __html: bannerTopicLong }} />
          </p>
        </div>

        {displayDeal && (
          <div className="w-1/2 flex justify-start">
            <CountdownTimer setDisplayDeal={setDisplayDeal} targetTime={midnight} />
          </div>
        )}
      </div>
    )
  }

  if (centered) {
    return (
      <>
        <div className={`flex items-center justify-center sm:px-16 ${className}`}>
          <p className="text-sm font-medium text-center sm:text-base md:mr-5 md:mb-0 " style={{ color: fontColor }}>
            <span className="md:hidden">
              <LinkRoute href={buttonProps.buttonUrl} className="text-white">
                <span dangerouslySetInnerHTML={{ __html: bannerTopic }}></span>
              </LinkRoute>
            </span>
            <span className="hidden md:inline" dangerouslySetInnerHTML={{ __html: bannerTopicLong }}></span>
          </p>
          <div className="hidden pl-4 sm:block">
            {buttonEnabled && (
              <>
                {scrollToSection ? (
                  <button
                    className={`inline-block text-center bg-[#006685] text-white py-2 px-2 border border-transparent rounded-full font-medium`}
                    style={{ backgroundColor: buttonProps.buttonColor, color: buttonProps.buttonTextColor }}
                    onClick={() => {
                      triggerTagging(`banner_cta_create_plan_${scrollToSection.id}`, `${scrollToSection.id}`)
                      scrollToSection?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }}
                  >
                    {buttonProps?.buttonText}
                  </button>
                ) : (
                  <LinkButton
                    buttonColor={buttonProps.buttonColor}
                    buttonText={buttonProps.buttonText}
                    loggedInButtonText={buttonProps.loggedInButtonText}
                    loggedInButtonUrl={buttonProps.loggedInButtonUrl}
                    buttonTextColor={buttonProps.buttonTextColor}
                    buttonUrl={buttonProps.buttonUrl}
                    isLink={buttonProps.isLink}
                    onClick={() => {
                      if (typeof window.gtag !== 'undefined') {
                        window.gtag('event', 'cta_button_click', {
                          page: 'homepage'
                        })
                      }
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
        {/* <div className="absolute inset-y-0 right-0 flex items-center pr-1 sm:items-center sm:pr-2">
          <button type="button" className="flex rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-white">
            <span className="sr-only">Dismiss</span>
            <FontAwesomeIcon icon={faX} className="h-6 w-6 text-white" aria-hidden="true" />
          </button>
        </div> */}
      </>
    )
  }

  return (
    <div className={`flex flex-wrap items-center justify-between ${className}`}>
      <div className="flex w-0 flex-1 items-center justify-center sm:justify-start">
        <p className="flex-1 ml-3 truncate text-sm font-medium sm:text-left sm:text-base" style={{ color: fontColor }}>
          <span className="md:hidden">
            <LinkRoute href={buttonProps.buttonUrl} className="text-white">
              <span dangerouslySetInnerHTML={{ __html: bannerTopic }}></span>
            </LinkRoute>
          </span>
          <span className="hidden md:inline" dangerouslySetInnerHTML={{ __html: bannerTopicLong }}></span>
        </p>
      </div>
      <div className="order-3 mt-2 hidden w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:block sm:w-auto">
        <LinkButton
          buttonColor={buttonProps.buttonColor}
          buttonText={buttonProps.buttonText}
          loggedInButtonText={buttonProps.loggedInButtonText}
          buttonTextColor={buttonProps.buttonTextColor}
          buttonUrl={buttonProps.buttonUrl}
          isLink={buttonProps.isLink}
          onClick={() => {
            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', 'cta_button_click', {
                page: 'homepage'
              })
            }
          }}
        />
      </div>
      <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
        {/* <button
          type="button"
          className="-mr-1 flex p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
        >
          <span className="sr-only">Dismiss</span>
          <XIcon className="h-6 w-6 " aria-hidden="true" />
        </button> */}
      </div>
    </div>
  )
}

const Content = ({
  bannerTopic,
  bannerTopicLong,
  buttonProps,
  centered,
  backgroundColor,
  fontColor,
  bannerTopicCarousel,
  bannerTopicLongCarousel,
  enableCarousel,
  buttonUrlCarousel,
  buttonTextCarousel,
  showTimer
}: any) => {
  return (
    <div
      className="relative bg-indigo-600"
      style={{ backgroundColor: backgroundColor, color: fontColor, zIndex: '999' }}
    >
      <div className={`mx-auto max-w-7xl py-3 ${showTimer ? '' : 'px-3'} sm:px-6 lg:px-8 relative`}>
        <InnerContent
          className={`${enableCarousel ? 'animate-fadeincarousel' : ''}`}
          bannerTopic={bannerTopic}
          bannerTopicLong={bannerTopicLong}
          enableCarousel={enableCarousel}
          buttonProps={buttonProps}
          centered={centered}
          fontColor={fontColor}
          showTimer={showTimer}
        />
        {enableCarousel && (
          <InnerContent
            className={`animate-fadeincarousel absolute opacity-0 [animation-delay:5000ms] inset-0`}
            bannerTopic={bannerTopicCarousel}
            bannerTopicLong={bannerTopicLongCarousel}
            enableCarousel={enableCarousel}
            buttonProps={{
              ...buttonProps,
              buttonText: buttonTextCarousel || buttonProps.buttonText,
              buttonUrl: buttonUrlCarousel || buttonProps.buttonUrl,
              loggedInButtonText: buttonTextCarousel || buttonProps.loggedInButtonText,
              loggedInButtonUrl: buttonUrlCarousel || buttonProps.loggedInButtonUrl
            }}
            centered={centered}
            fontColor={fontColor}
            showTimer={showTimer}
          />
        )}
      </div>
    </div>
  )
}

const Banner = ({
  bannerTopic,
  bannerTopicLong,
  bannerTopicCarousel,
  bannerTopicLongCarousel,
  enableCarousel,
  stickyBottom,
  buttonProps,
  centered,
  backgroundColor,
  fontColor,
  bannerPosition,
  buttonUrlCarousel,
  buttonTextCarousel,
  showCustomText,
  buttonEnabled = true,
  showTimer = false
}: Props) => {
  const {
    isValidCoupon,
    lastValidatedCoupons
  }: {
    isValidCoupon: boolean
    lastValidatedCoupons: CouponsType[]
  } = useSelector((state: RootState) => state.dog)
  const [bannerMessage, setBannerMessage] = useState(bannerTopic)
  const [bannerMessageLong, setBannerMessageLong] = useState(bannerTopicLong)

  const dispatch = useDispatch()

  useEffect(() => {
    if (showCustomText) {
      // Check for coupon in cache and validate
      let coupon = Cache.getItem('coupon') ?? null
      if (coupon) {
        dispatch(updateCouponCodeValidity('checkValidity', coupon as string))
      }
    }
  }, [showCustomText])

  useEffect(() => {
    // Create custom message
    if (isValidCoupon && lastValidatedCoupons?.length > 0 && showCustomText) {
      const first = lastValidatedCoupons[0]

      const firstDiscount =
        first.type === 'percentage' ? `${first.amount}% off` : `£${(first.amount / 100).toFixed(2)} off`

      const firstBoxes = first.uses > 1 ? `your first ${first.uses} boxes` : 'your first box'

      let message = `${firstDiscount} ${firstBoxes}`

      if (lastValidatedCoupons.length > 1) {
        const second = lastValidatedCoupons[1]
        const secondDiscount =
          second.type === 'percentage' ? `${second.amount}% off` : `£${(second.amount / 100).toFixed(2)} off`

        const secondBoxes = second.uses > 1 ? `your next ${second.uses} boxes` : 'your next box'

        message += `, ${secondDiscount} ${secondBoxes}`
      }

      message += '!'

      setBannerMessage(message)
      setBannerMessageLong(`${message} Use code ${first.code}`)
    } else {
      // Reset back to default message to prevent stale text
      setBannerMessage(bannerTopic)
      setBannerMessageLong(bannerTopicLong)
    }
  }, [isValidCoupon, lastValidatedCoupons, showCustomText])

  const handleBtnText = () => {
    if (window.innerWidth < 400) {
      if (buttonProps?.buttonText) buttonProps.buttonText = 'Get Started'
    } else {
      if (buttonProps?.buttonText) buttonProps.buttonText = 'Create Plan'
    }
  }

  useEffect(() => {
    handleBtnText()
    window.addEventListener('resize', handleBtnText)

    return () => {
      window.removeEventListener('resize', handleBtnText)
    }
  }, [])

  if (stickyBottom) {
    return (
      <a href={buttonProps.buttonUrl} style={{ display: 'block', textDecoration: 'none' }}>
        <StickyWrapper position={bannerPosition}>
          <Content
            bannerTopic={bannerMessage}
            bannerTopicLong={bannerMessageLong}
            bannerTopicCarousel={bannerTopicCarousel}
            bannerTopicLongCarousel={bannerTopicLongCarousel}
            enableCarousel={enableCarousel}
            buttonProps={buttonProps}
            buttonUrlCarousel={buttonUrlCarousel}
            buttonTextCarousel={buttonTextCarousel}
            centered={centered}
            backgroundColor={backgroundColor}
            fontColor={fontColor}
            buttonEnabled={buttonEnabled}
          />
        </StickyWrapper>
      </a>
    )
  }

  return (
    <a href={buttonProps.buttonUrl} style={{ display: 'block', textDecoration: 'none' }}>
      <Content
        bannerTopic={bannerMessage}
        bannerTopicLong={bannerMessageLong}
        bannerTopicCarousel={bannerTopicCarousel}
        bannerTopicLongCarousel={bannerTopicLongCarousel}
        enableCarousel={enableCarousel}
        buttonUrlCarousel={buttonUrlCarousel}
        buttonTextCarousel={buttonTextCarousel}
        buttonProps={buttonProps}
        centered={centered}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
        buttonEnabled={buttonEnabled}
      />
    </a>
  )
}

export default Banner
